import "./legal-disclosure.scss"
import "./db-journey/index.scss"
import "./roadsurfer/index.scss"

require.context("./db-journey/static", true, /\.jpg|webp|svg$/)
require.context("./roadsurfer/static", true, /\.jpg|webp|svg$/)
